export default __webpack_public_path__ + "static/media/Step-2-safari.c9a1128d.mov";